import React, { useContext, useEffect, useRef, useState } from "react";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import axios from "axios";
import TableFooter from "../../components/TableFooter";
import NoSearchitems from "../../components/NoSearchitems";
import { IoCopyOutline } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { BiEditAlt } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import VanishComponent from "../../components/VanishComponent";
import DownloadLoadingModal from "../../components/DownloadLoadingModal";
import AddNewDistributor from "./modals/AddNewDistributor";
import DistributorTopBar from "./components/DistributorTopBar";
import AreYouSureModal from "../../components/AreYouSure";
import IOSSwitch from "../Settings/toggle";
import { sideBarContext } from "../../App";

const NewDistributors = () => {
  const { expanded } = useContext(sideBarContext);
  // const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [actionBox, setActionBox] = useState(false);

  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);

  const [showUserDetails, setShowUserDetails] = useState();

  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(rowsPerPage);

  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [searchPages, setSearchPages] = React.useState();
  const [searchRows, setSearchRows] = React.useState();
  const [imageLoading, setImageLoading] = useState(false);
  const [searchEmpty, setSearchEmpty] = useState(false);

  const storedPage = parseInt(sessionStorage.getItem("currentPage"), 10) || 1;
  //const storedSearch = sessionStorage.getItem("query") || "";
  const [pageNo, setPageNo] = React.useState(storedPage);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [deletedName, setDeletedName] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [noDownloadData, setNoDownloadData] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [divPosition, setDivPosition] = useState({
    top: 100,
    left: 100,
  });
  const [copyArray, setCopyArray] = useState([]);
  let timer = "";
  const [openActionIndex, setOpenActionIndex] = useState(null);

  const divRef = useRef(null);
  const buttonRef = useRef(null);
  const [addNewModal, setAddNewModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [addedSuccess, setAddedSuccess] = useState(false);
  const [existError, setExistError] = useState(false);
  const [editData, setEditData] = useState(null);
  const [toggleModal, setToggleModal] = useState(false);
  const [toggleDetails, setToggleDetails] = useState({});
  const [addErrorMessage, setAddErrorMessage] = useState("");

  const closeSuccess = () => {
    setAddedSuccess((prev) => !prev);
  };
  const toggleExistError = () => {
    setExistError((prev) => !prev);
  };

  const fetchUsers = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/distributors?page=${pageNo}&rows_per_page=${rowsPerPage}`,
        options
      );
      setSearchList([]);
      setTotalPages(res.data.total_pages);
      setTotalRows(res.data.total_entries);
      setList(res.data.distributor_details);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const IndividualPartnerDownload = async (id) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/consolidated?type=excel&file_name=earning_report&distributor_id=${id}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.response.status) {
        handleDownloadFile(res.data.response.data);
      }
    } catch (error) {
      setNoDownloadData(true);
    } finally {
      setDownloadLoading(false);
    }
  };
  const handlePosition = (e) => {
    const rowRect = e.currentTarget.getBoundingClientRect();
    const topValue = (rowRect.bottom + window.scrollY).toFixed(2);
    const leftValue = rowRect.left + window.scrollX;
    const divTop = topValue + 12;
    const divLeft = leftValue - 78;

    setDivPosition({ top: divTop, left: divLeft });
  };

  const diabledCopyStyle = {
    width: "15px",
    height: "15px",
    color: "#c6c6c6",
    backgroundColor: "#f3f3f3",
  };
  const enabledCopyStyle = {
    width: "15px",
    height: "15px",
    color: "#00394d",
    backgroundColor: "#ffffff",
  };

  const displayedRows = list.length > 0 ? list : searchList;
  const noOfRows = list.length > 0 ? totalRows : searchRows;
  const noOfPages = list.length > 0 ? totalPages : searchPages;
  const handleDistributorDelete = async (i) => {
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/distributors/${i.id}`,
        method: "DELETE",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.status === 200) {
        setSearchList([]);
        const controller = new AbortController().signal;
        fetchUsers(controller);
        setDeletedName(i.name);
        setShowDelete(true);
        setDeleteModal(false);
      }
    } catch (error) {}
  };
  const handleCopy = (link, index) => {
    if (!document.hasFocus()) {
      return;
    }
    if (link === undefined || link === null) return;
    clearTimeout(timer);
    navigator.clipboard.writeText(link);
    const temArr = list?.map(() => false);
    temArr[index] = true;
    setCopyArray(temArr);
  };
  const handleOverlay = (e) => {
    if (e.target === e.currentTarget) {
      setActionBox(false);
    }
    return;
  };
  const toggleStatus = async (id, status) => {
    try {
      const formData = new FormData();

      // Append data to formData
      formData.append("toggle", status);

      const token = localStorage.getItem("token");
      // console.log(distributor.id)
      // console.log(imageRemoved)
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/distributors/${id}`,
        method: "PUT",
        headers: {
          Authorization: token,
          "Content-Type": `multipart/form-data`,
        },
        data: formData,
      };
      const res = await axios(options);
      if (res.data.response === "Successfully Updated" && res.status === 200) {
        const controller = new AbortController().signal;
        fetchUsers(controller);
        setToggleModal(false);
      }
    } catch (error) {}
  };
  useEffect(() => {
    const controller = new AbortController();
    const fetchSearchedUsers = async (controller) => {
      const token = localStorage.getItem("token");
      setImageLoading(true);
      const options = {
        method: "GET",
        headers: { Authorization: token },
        signal: controller.signal,
      };
      try {
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/distributors/search?search_field=name&search_term=${searchQuery}&page=${pageNo}&rows_per_page=${rowsPerPage}`,
          options
        );
        setTotalPages(res.data.total_pages);
        setTotalRows(res.data.total_entries);
        setList(res.data.distributor_details);
        if (res.data.distributor_details.length < 1) {
          setSearchEmpty(true);
          // console.log(searchEmpty);
          setSearchPages(res.data.total_pages);
          setSearchRows(res.data.total_entries);
        }
        if (res.data.distributor_details.length > 0) {
          setSearchEmpty(false);
        }

        // setRowsPerPage(res.data.distributor_details.length);
      } catch (error) {
        console.log(error);
      } finally {
        setImageLoading(false);
      }
    };

    if (searchQuery !== "") {
      fetchSearchedUsers(controller);
      setList([]);
    }
    if (searchQuery === "") {
      fetchUsers(controller);
      setSearchList([]);
      setSearchEmpty(false);
    }

    return () => {
      controller.abort();
    };
  }, [searchQuery, pageNo, rowsPerPage]);

  useEffect(() => {
    let timer1 = setTimeout(() => {
      setCopyArray(list?.map(() => false));
    }, 3000);

    return () => {
      clearTimeout(timer1);
    };
  }, [copyArray]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);

  return (
    <div
      className={` ${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px]`}
    >
      <div className="mt-4 rounded-lg bg-white mb-4 p-4">
        <p className="text-[#262626] text-xl font-semibold">Distributors</p>
      </div>
      <div className=" bg-white px-4 flex flex-col justify-between pt-2 rounded-t-lg">
        <DistributorTopBar
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showButton={true}
          downloadPageWord="distributors"
          clickFunction={() => {
            setEditData(null);
            setAddNewModal(true);
          }}
        />
      </div>
      {!showUserDetails ? (
        <>
          <div className="pt-3 w-full bg-white">
            {imageLoading && (
              <div className="w-full h-[calc(100vh-245px)] flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {!imageLoading && (
              <table className="w-full box-border h-full flex flex-col">
                <thead className="text-sm font-semibold h-full">
                  <tr className="w-full flex items-center pb-1 relative">
                    <th
                      className={`text-left w-[4%] text-sm font-semibold pl-5`}
                    ></th>
                    <th className={`text-left w-[20%] text-sm font-semibold `}>
                      Name
                    </th>

                    <th
                      className={`text-center w-[12%] text-sm font-semibold `}
                    >
                      Logo
                    </th>
                    <th className="text-center  w-[20%] text-sm font-semibold">
                      Link
                    </th>
                    <th className="text-left  w-[17%] text-sm font-semibold pl-[4%]">
                      Credit Type
                    </th>
                    <th className="text-left w-[17%] text-sm font-semibold  pl-[5%]">
                      Downloads
                    </th>
                    <th className="text-center w-[15%] text-sm font-semibold  pl-[5%]">
                      Status
                    </th>

                    <th className="text-right w-[16%] text-sm font-semibold pr-6">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`overflow-visible overflow-y-scroll  max-h-[calc(100vh-280px)] ${
                    displayedRows.length === 0 ||
                    (searchEmpty && searchQuery !== "")
                      ? "h-[calc(100vh-245px)]"
                      : ""
                  }`}
                >
                  {searchEmpty && searchQuery !== "" ? (
                    <>
                      <NoSearchitems />
                    </>
                  ) : (
                    <>
                      {displayedRows.length ? (
                        <>
                          {displayedRows?.map((i, index) => (
                            <tr
                              key={index}
                              className={`${
                                index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                              }  text-xs font-medium w-full flex items-center hover:bg-[#E6EBED]`}
                            >
                              <td
                                className={`text-left w-[4%] text-xs font-medium text-[#004682] pl-5`}
                              >
                                {startIndex + index + 1}
                              </td>
                              <td
                                className={` pt-3 pb-2 text-left w-[20%] text-xs font-medium text-[#004682]`}
                              >
                                {i?.name || "--"}
                              </td>
                              <td
                                className={`flex justify-center w-[12%] text-xs font-medium`}
                              >
                                {i.logo ? (
                                  <img
                                    width={30}
                                    src={i.logo}
                                    alt="logo"
                                    className=" h-[30px] w-[30px] object-contain"
                                  />
                                ) : (
                                  "--"
                                )}
                              </td>
                              <td className="flex justify-center  w-[20%] text-xs font-medium">
                                {!copyArray[index] && (
                                  <>
                                    {" "}
                                    <button
                                      disabled={
                                        i.link === null ||
                                        i.link === undefined ||
                                        i.link === ""
                                      }
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleCopy(i.link, index);
                                      }}
                                      className={` p-[4px] border  rounded ${
                                        i.link === null ||
                                        i.link === undefined ||
                                        i.link === ""
                                          ? "border-[#c6c6c6] bg-[#f3f3f3] cursor-default"
                                          : "border-[#00304d] bg-white "
                                      }`}
                                    >
                                      <IoCopyOutline
                                        style={
                                          i.link === undefined ||
                                          i.link === null ||
                                          i.link === ""
                                            ? diabledCopyStyle
                                            : enabledCopyStyle
                                        }
                                      />
                                    </button>
                                  </>
                                )}
                                {copyArray[index] && (
                                  <p
                                    className="text-xs  font-medium  items-center text-[#47b971] border border-[#47b971] rounded-[4px] inline-flex bg-white px-[5px] py-[3px]"
                                    onClick={(event) => event.stopPropagation()}
                                  >
                                    <span className=" mr-1">
                                      <FaCheck />{" "}
                                    </span>
                                    Link Copied
                                  </p>
                                )}
                              </td>

                              <td className="text-left  w-[17%] text-xs font-medium pl-[4%]">
                                {i?.credit_type || "--"}
                              </td>
                              <td
                                className={`text-left w-[17%] text-xs font-medium pl-[5%]`}
                              >
                                <button
                                  className=" p-[3px] bg-white border border-[#00304d] rounded hover:bg-[#f6f6f6]"
                                  onClick={() =>
                                    IndividualPartnerDownload(i.id)
                                  }
                                >
                                  <FiDownload
                                    style={{
                                      color: "#00394d",
                                      width: "15px",
                                      height: "15px",
                                    }}
                                  />
                                </button>
                              </td>
                              <td className="flex justify-center w-[15%] text-sm   pl-[6%]">
                                <span className=" mr-4">
                                  <IOSSwitch
                                    checked={i.is_active}
                                    onClick={
                                      () => {
                                        setToggleDetails({
                                          id: i.id,
                                          status: !i.is_active,
                                        });
                                        setToggleModal((prev) => !prev);
                                      }
                                      // toggleStatus(i.id, !i.is_active)
                                    }
                                  />
                                </span>
                              </td>
                              <td
                                className={`text-right w-[16%] text-xs font-medium pr-6`}
                              >
                                <button
                                  ref={buttonRef}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handlePosition(event);
                                    setDeleteId(i);
                                    setActionBox(true);
                                  }}
                                  className=" p-[3px] bg-white border border-[#00304d] rounded hover:bg-[#f6f6f6] relative"
                                >
                                  <HiOutlineDotsHorizontal
                                    style={{
                                      color: "#00394d",
                                      width: "15px",
                                      height: "15px",
                                    }}
                                  />
                                </button>
                              </td>
                              {actionBox && (
                                <div
                                  className=" overlayModal2"
                                  onClick={handleOverlay}
                                >
                                  <div
                                    ref={divRef}
                                    style={{
                                      top: `${divPosition.top}px`,
                                      left: `${divPosition.left}px`,
                                    }}
                                    className=" shadow-md w-[102px] h-[84px] rounded-lg absolute bg-white  p-1 z-[1000] flex flex-col justify-between text-xs"
                                  >
                                    <button
                                      onClick={() => {
                                        setEditData(deleteId);
                                        setAddNewModal(true);
                                        setActionBox(false);
                                      }}
                                      className=" w-full h-9 bg-[#f7faff] hover:bg-[#eef4ff] rounded-lg flex items-center justify-center font-medium"
                                    >
                                      <span className=" mr-2 font-bold">
                                        <BiEditAlt size={16} />
                                      </span>{" "}
                                      Edit
                                    </button>
                                    <button
                                      disabled={!deleteId.delete}
                                      onClick={() => {
                                        setDeleteModal(true);

                                        setActionBox(false);
                                        console.log(deleteId);
                                      }}
                                      className={` w-full h-9 bg-[#fef4f5]  rounded-lg flex items-center justify-center font-medium ${
                                        deleteId.delete === true
                                          ? "hover:bg-[#ffedef]"
                                          : "text-[#848484] "
                                      }`}
                                    >
                                      <span className=" mr-2 font-bold">
                                        <MdDeleteOutline size={16} />
                                      </span>{" "}
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              )}
                            </tr>
                          ))}
                        </>
                      ) : (
                        <>
                          <NoDataFound insidePage={false} />
                        </>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            )}
          </div>
          <TableFooter
            totalPages={noOfPages}
            totalRows={noOfRows}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            endIndex={endIndex}
            setStartIndex={setStartIndex}
            setEndIndex={setEndIndex}
            setPageNo={setPageNo}
            pageNo={pageNo}
            setRowsPerPage={setRowsPerPage}
          />
          {downloadLoading && <DownloadLoadingModal />}
          <VanishComponent
            error={noDownloadData}
            errorFunction={() => {
              setNoDownloadData(false);
            }}
            errorMessage={`No records found`}
            timeOut={5000}
          />
          <VanishComponent
            success={showDelete}
            successFunction={() => {
              setShowDelete(false);
            }}
            successMessage={` deleted successfully`}
            timeOut={10000}
            deleteName={deletedName}
          />
          <VanishComponent
            error={existError}
            success={addedSuccess}
            errorMessage={addErrorMessage}
            successMessage={addedSuccess}
            errorFunction={toggleExistError}
            successFunction={closeSuccess}
            timeOut={10000}
          />
          {addNewModal && (
            <AddNewDistributor
              setModal={setAddNewModal}
              fetchUsers={fetchUsers}
              setAddNewModal={setAddNewModal}
              setAddedSuccess={setAddedSuccess}
              setExistError={setExistError}
              editData={editData}
              setAddErrorMessage={setAddErrorMessage}
            />
          )}
          {deleteModal && (
            <AreYouSureModal
              yesFunction={() => handleDistributorDelete(deleteId)}
              yes={"Delete"}
              no={"Cancel"}
              noFunction={() => setDeleteModal(false)}
            />
          )}
          {toggleModal && (
            <AreYouSureModal
              yesFunction={() =>
                toggleStatus(toggleDetails.id, toggleDetails.status)
              }
              yes={"Yes"}
              no={"Cancel"}
              noFunction={() => setToggleModal(false)}
              message={"This action will change the status of the distributor"}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default NewDistributors;
